import { theme as lightTheme } from 'cdk-radial';
import { useSearchParams } from 'react-router-dom';
import { useStore } from 'store/store';
import styled from 'styled-components';

export const Tag = styled(({ className, active, tag }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  // tags and any will be null if they are not present in the querystring
  // if present, they will be url-decoded so %20 will become a space and %2C will become a comma
  const tags = searchParams.get('tags');
  const any = searchParams.get('any');

  const lowerCaseTag = tag.toLowerCase();

  // if the tag is active, remove it
  // if the tag is not active, add it
  // tags is a comma-separated string of tags.
  const handleTag = () => {
    // if tag is active, make an array so we can remove the clicked tag
    const newTags = active
      ? tags
          .split(',')
          .filter((item) => item !== lowerCaseTag)
          .join(',')
      : // if the tag is not active, we want to add the tag.
      // check to see if any tags are active
      tags !== null
      ? // if other tags are active, use a comma and append the new tag, otherwise just use the new tag
        `${tags},${lowerCaseTag}`
      : lowerCaseTag;

    if (newTags.length > 0) {
      // if the any filter is present, we need to keep it
      if (any !== null) setSearchParams({ tags: newTags, any: 'true' });
      else setSearchParams({ tags: newTags });
      // if no tags are active, clear the querystring
    } else setSearchParams({});
  };

  const tagClass = active ? `active ${className}` : className;

  return (
    <button className={tagClass} onClick={handleTag}>
      {tag}
    </button>
  );
})`
  background: ${() => {
    const headerConfig = useStore((state) => state.headerConfig);
    return headerConfig.tagBackground;
  }};
  border-radius: ${({ theme }) => theme.size.borderRadius.small.value};
  border: 0;
  color: ${lightTheme.color.additional.dark.value};
  font-size: ${({ theme }) => theme.font.size.captionSmall.value};
  font-weight: ${({ theme }) => theme.font.weight.regular.value};
  padding: 4px 6px;
  transition: background ${({ theme }) => theme.transition.duration.value},
    color ${({ theme }) => theme.transition.duration.value};
  &.active,
  &.active:hover {
    background: ${() => {
      const headerConfig = useStore((state) => state.headerConfig);
      return headerConfig.tagSelected;
    }};
    color: ${lightTheme.color.additional.light.value};
  }
  &:hover {
    color: ${lightTheme.color.additional.dark.value};
    cursor: pointer;
    background: ${() => {
      const headerConfig = useStore((state) => state.headerConfig);
      return headerConfig.tagHover;
    }};
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;
